
export interface INewAccount {
  email: string;
  mobile: string;
  name: string;
  postCode: number;
  nationality: number;
  birthDate: Date;
}

export interface ILoggedInPatient {
  firstName: string;
  middleName: string;
  lastName: string;
  displayName: string;
  accountPreferences: IAccountPreferences;
  accountDetails: IAccountDetails;
}

export interface IAccountPreferences {
  defaultLanguageKey: number;
}

export interface IAccountDetails {
  userName: string;
  firstTimeLogin: boolean;
  previousLoginDate: Date;
  passwordExpirationDaysLeft: number;
}

export class AuthToken {
  expires_in: number;
  access_token: string;
  refresh_token: string;
}

export interface IDictionary<T> {
  [Key: string]: T;
}

export enum LogoutReason {
  Manual,
  Automatic
}

